import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Prompt for an explanation of some nodes in a flow
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestExplainFlowNodes = packet => {
  return {
    type: 'REQUEST_EXPLAIN_FLOW_NODES',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveExplainFlowNodesSuccess = data => ({
  type: 'RECEIVE_EXPLAIN_FLOW_NODES_SUCCESS',
  data
})

export const receiveExplainFlowNodesFail = data => ({
  type: 'RECEIVE_EXPLAIN_FLOW_NODES_FAIL',
  data
})

export const tryToExplainFlowNodes = packet => (dispatch, getState) => {

  dispatch(requestExplainFlowNodes(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  

  let fs = Cookies.get(process.env.REACT_APP_COOKIE_FEATURE_SWITCH)
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/explain-nodes/' + packet.id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveExplainFlowNodesSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveExplainFlowNodesFail({errors:e, lastSubmit: packet}));
    })
}
